module.exports = __webpack_public_path__ + "media/images/pic/hero/farm-2af16b9b369cdefcd6a6e73d7f973baa.webp";